module.exports = __webpack_public_path__ + "img/306.80c08619.png";